import AFPayCardSwiper from './AFPayCardSwiper'
import AFPayOptionLayer from './AFPayOptionLayer'
import { MyPayInfo } from '../../../@types/cart'
import { PaymentInfoItem } from '../../../@types/order'

interface AFPayProps {
  isMember: boolean
  myPayData: MyPayInfo
  payUserRegister: string
  cardInfos: PaymentInfoItem[]
  setCardDelete: React.Dispatch<React.SetStateAction<boolean>>
  setChangePayData: React.Dispatch<React.SetStateAction<boolean>>
  setCardInfo: React.Dispatch<React.SetStateAction<PaymentInfoItem | null>>
  setCardInfos: React.Dispatch<React.SetStateAction<PaymentInfoItem[]>>
  deleteModal: boolean
  setDeleteModal: React.Dispatch<React.SetStateAction<boolean>>
}

const AFPay = ({
  isMember,
  cardInfos,
  myPayData,
  payUserRegister,
  setCardDelete,
  setChangePayData,
  setCardInfo,
  setCardInfos,
  deleteModal,
  setDeleteModal,
}: AFPayProps) => {
  return (
    <>
      {/* 어바웃피싱 페이 선택 시 카드 스와이퍼/등록 버튼/옵션 버튼 */}
      <AFPayCardSwiper
        isMember={isMember}
        cardInfos={cardInfos}
        setCardInfo={setCardInfo}
        myPayData={myPayData}
        payUserRegister={payUserRegister}
      />
      <AFPayOptionLayer
        payUserRegister={payUserRegister}
        cardInfos={cardInfos}
        setCardDelete={setCardDelete}
        setChangePayData={setChangePayData}
        setCardInfos={setCardInfos}
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
      />
    </>
  )
}

export default AFPay
